import ActionMenu from "./ActionMenu";
import Header from "./Header";
import SummaryElement from "./SummaryElement";
import { CloseRounded as CloseIcon } from "@mui/icons-material";
import { Box, Skeleton, Stack } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import DefaultLoader from "components/common/DefaultLoader";
import IconButton from "components/common/IconButton";
import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import * as bffService from "services/bffService";

const POLLING_INTERVAL_MS = 1_000;

const Details = () => {
  const theme = useTheme();
  const navigate = useNavigate();

  const [pollingInterval, setPollingInterval] = useState(POLLING_INTERVAL_MS);

  const { formId } = useParams();
  const { data: form, isLoading, refetch } = bffService.useRetrieveFormQuery(
    { formId },
    {
      skip: formId == null,
      pollingInterval,
    }
  );

  useEffect(() => {
    if (form?.isQuoteProcessing === true) {
      setPollingInterval(POLLING_INTERVAL_MS);
    } else if (form?.isQuoteProcessing === false) {
      setPollingInterval(null);
    }
  }, [form, setPollingInterval]);

  useEffect(() => {
    if (formId) {
      refetch();
    }
  }, [formId, refetch]);

  const headerConfig = {
    title: form?.formData["applicant"],
    background: theme.brand.gray[500],
    color: "black",
  };

  const summaryConfig = [
    { label: "Quote", format: "title" },
    { label: "Producer", key: "producer", format: "producer" },
    { format: "layers" },
    { label: "Subjectivities", format: "subjectivities" },
    { label: "Cover", format: "title" },
    { label: "Policy Number", format: "policyNumber" },
    { label: "Inception", key: "inception", format: "date" },
    { label: "Retroactive Date", key: "retro", exposureFlag: "RETRO" },
    { label: "Risk Details", format: "title" },
    { label: "Insured Address", key: "address", multiline: true },
    { label: "Revenue", key: "revenue", format: "currency" },
    { label: "Risk Summary", key: "summary", multiline: true },
    { label: "Experience", key: "experience", exposureFlag: "EXPERIENCE" },
    { label: "Claims", key: "claims", exposureFlag: "CLAIMS" },
  ];

  return (
    <div className={"app"}>
      <div className={"component"}>
        <Header
          config={headerConfig}
          status={form?.status}
          ActionItems={
            false ? (
              <Stack direction={"row"} gap={1}>
                <Skeleton width={90} />
                <IconButton icon={CloseIcon} disabled />
              </Stack>
            ) : (
              <ActionMenu
                form={form}
                refetch={refetch}
                onEdit={() => navigate(`/forms/${formId}/edit`)}
                onClose={() => navigate("/forms")}
              />
            )
          }
        />
        <Box sx={{ maxWidth: "40rem", margin: "0 auto" }}>
          {isLoading ? (
            <DefaultLoader
              size={100}
              style={{
                position: "fixed",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
              }}
            />
          ) : (
            <SummaryElement form={form ?? {}} items={summaryConfig} />
          )}
        </Box>
      </div>
    </div>
  );
};

export default Details;
